<div id="loding" [ngClass]="{ 'loding-hide': lodingImage }">
  <img src="assets/img/loding.gif" />
</div>
<div id="ui-view" [ngClass]="{ 'loding-ui-view': showloding }">
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12" style="margin: 0 auto">
        <div class="card">
          <div class="card-block">
            <h5 class="card-title" style="display: inline-block">User Role</h5>
            {{ userName }} -
            <span class="badge badge-success">{{
              userType == 1 ? "Admin" : "User"
            }}</span>

            <div class="accordion" id="mainAccordion">
              <!-- WEP -->
              <div class="card" *ngIf="wepMenuList && wepMenuList.length > 0">
                <div class="card-header" id="headingWEPMain">
                  <h5 class="mb-0">
                    <button
                      class="btn btn-link"
                      data-toggle="collapse"
                      data-target="#collapseWEPMain"
                      aria-expanded="true"
                      aria-controls="collapseWEPMain"
                    >
                      <span class="icon"></span>
                      WEP Menu
                    </button>
                  </h5>
                </div>

                <div
                  id="collapseWEPMain"
                  class="collapse show"
                  aria-labelledby="headingWEPMain"
                  data-parent="#mainAccordion"
                >
                  <div class="card-body">
                    <div class="child-accordion" id="innerAccordionWEP">
                      <div class="card" *ngFor="let item of wepMenuList">
                        <div
                          class="card-header"
                          id="headingChildWEP{{ item.id }}"
                        >
                          <h5 class="mb-0">
                            <button
                              class="btn btn-link d-flex justify-content-between align-items-center"
                              type="button"
                              (click)="toggleChild(item, 'wep')"
                              [attr.aria-expanded]="item.expanded"
                            >
                              <span class="d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  (click)="$event.stopPropagation()"
                                  [id]="'menu_wep_' + item.id"
                                  [value]="item.id"
                                  [checked]="item.checked"
                                  (change)="selectMenu($event, item)"
                                />
                                <span class="ml-2">{{ item.label }}</span>
                              </span>

                              <!-- arrow inside the button so CSS can see it -->
                              <span
                                class="arrow ml-2"
                                *ngIf="item.children.length"
                              ></span>
                            </button>
                          </h5>
                        </div>

                        <div
                          *ngIf="item.children.length"
                          id="collapseChildWEP{{ item.id }}"
                          class="collapse"
                          [class.show]="item.expanded"
                          [attr.aria-labelledby]="'headingChildWEP' + item.id"
                        >
                          <div class="card-body">
                            <div class="row">
                              <div
                                class="col-md-2"
                                *ngFor="let child of item.children"
                              >
                                <input
                                  type="checkbox"
                                  (click)="$event.stopPropagation()"
                                  [id]="'submenu_wep_' + child.sub_id"
                                  [value]="child.sub_id"
                                  [checked]="child.checked"
                                  (change)="selectSubMenu($event, item, child)"
                                />
                                {{ child.label }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- CII -->
              <div class="card" *ngIf="ciiMenuList && ciiMenuList.length > 0">
                <div class="card-header" id="headingCIIMain">
                  <h5 class="mb-0">
                    <button
                      class="btn btn-link"
                      data-toggle="collapse"
                      data-target="#collapseCIIMain"
                      aria-expanded="false"
                      aria-controls="collapseCIIMain"
                    >
                      <span class="icon"></span>
                      CII Menu
                    </button>
                  </h5>
                </div>

                <div
                  id="collapseCIIMain"
                  class="collapse"
                  aria-labelledby="headingCIIMain"
                  data-parent="#mainAccordion"
                >
                  <div class="card-body">
                    <div class="child-accordion" id="innerAccordionCII">
                      <div class="card" *ngFor="let item of ciiMenuList">
                        <div
                          class="card-header"
                          id="headingChildCII{{ item.id }}"
                        >
                          <h5 class="mb-0">
                            <button
                              class="btn btn-link d-flex justify-content-between align-items-center"
                              type="button"
                              (click)="toggleChild(item, 'cii')"
                              [attr.aria-expanded]="item.expanded"
                            >
                              <span class="d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  (click)="$event.stopPropagation()"
                                  [id]="'menu_cii_' + item.id"
                                  [value]="item.id"
                                  [checked]="item.checked"
                                  (change)="selectMenu($event, item)"
                                />
                                <span class="ml-2">{{ item.label }}</span>
                              </span>

                              <span
                                class="arrow ml-2"
                                *ngIf="item.children.length"
                              ></span>
                            </button>
                          </h5>
                        </div>

                        <div
                          *ngIf="item.children.length"
                          id="collapseChildCII{{ item.id }}"
                          class="collapse"
                          [class.show]="item.expanded"
                        >
                          <div class="card-body">
                            <div class="row">
                              <div
                                class="col-md-2"
                                *ngFor="let child of item.children"
                              >
                                <input
                                  type="checkbox"
                                  (click)="$event.stopPropagation()"
                                  [id]="'submenu_cii_' + child.sub_id"
                                  [value]="child.sub_id"
                                  [checked]="child.checked"
                                  (change)="selectSubMenu($event, item, child)"
                                />
                                {{ child.label }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group" style="padding-top: 15px">
              <button
                type="submit"
                class="btn btn-primary savebtn rounded"
                (click)="update()"
              >
                Update
              </button>
              <button class="btn btn-dark ml-3 rounded" (click)="back()">
                Back
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
